/*
 * TEMPLARY — Night Mode controller.
 *
 * The theme is applied BEFORE render by an inline script in `snippets/night-mode.liquid`
 * (anti-FOUC). This file only handles user intent: toggling, persistence, the discreet
 * after-hours suggestion, and keeping toggle buttons in sync. Colours live in CSS tokens
 * (`:root[data-theme="night"]`) — never duplicated here.
 */
(function () {
  'use strict';

  var KEY = 'templary-theme';
  var SUGGEST_KEY = 'templary-theme-suggested';
  var root = document.documentElement;

  function current() {
    return root.getAttribute('data-theme') === 'night' ? 'night' : 'day';
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Apply a theme. `animate` enables the one-shot cross-fade (never on first paint).
  function apply(theme, animate) {
    if (animate && !prefersReducedMotion()) {
      root.setAttribute('data-theme-anim', '');
      window.clearTimeout(apply._timer);
      apply._timer = window.setTimeout(function () {
        root.removeAttribute('data-theme-anim');
      }, 650);
    }
    if (theme === 'night') {
      root.setAttribute('data-theme', 'night');
    } else {
      root.removeAttribute('data-theme');
    }
    try { localStorage.setItem(KEY, theme); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('tw-theme:change', { detail: { theme: theme } }));
  }

  function toggle() {
    apply(current() === 'night' ? 'day' : 'night', true);
  }

  // Keep every toggle button's accessible state in sync (labels/glyphs are pure CSS).
  function sync() {
    var isNight = current() === 'night';
    var buttons = document.querySelectorAll('[data-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', isNight ? 'true' : 'false');
      buttons[i].setAttribute('aria-label', isNight ? 'Switch to day mode' : 'Switch to night mode');
    }
  }

  window.TemplaryTheme = {
    get: current,
    toggle: toggle,
    set: function (theme) { apply(theme, true); }
  };

  // Delegated: any [data-theme-toggle] control flips the theme.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle();
  });

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    sync();
    maybeSuggest();
  });

  // Discreet after-hours suggestion — shown once, never forces the change.
  function maybeSuggest() {
    if (current() === 'night') return; // already there
    var seen = null;
    try { seen = localStorage.getItem(SUGGEST_KEY); } catch (e) {}
    if (seen) return;
    var hour = new Date().getHours();
    if (!(hour >= 20 || hour < 6)) return; // only during night hours
    try { localStorage.setItem(SUGGEST_KEY, '1'); } catch (e) {}
    showSuggestion();
  }

  function showSuggestion() {
    var el = document.createElement('div');
    el.className = 'tw-night-suggest';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<span class="tw-night-suggest__text">Night Mode is available.</span>' +
      '<button type="button" class="tw-night-suggest__action" data-theme-toggle>ENTER</button>' +
      '<button type="button" class="tw-night-suggest__close" aria-label="Dismiss">×</button>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });

    var hide = function () {
      el.classList.remove('is-visible');
      window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 500);
    };
    el.querySelector('.tw-night-suggest__close').addEventListener('click', hide);
    el.querySelector('.tw-night-suggest__action').addEventListener('click', hide);
    window.setTimeout(hide, 8000);
  }
})();
